import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function MenuDown(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M7 10L12 15L17 10H7Z" />
    </SvgIcon>
  )
}
